import React, { PropTypes } from 'react';
import LightBox from '../Common/LightBox';
import moment from 'moment';

export default class AccessItem extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			x: 0, y: 0, 
			isFilesOpen: false, 
			isMapOpen: false, 
			isDetailsOpen: false, 
			locations: {}, 
			files: [],
			details: {} 
		};
	}UsuarioItem

	getStyle(width = 400, height = 400) {
		const top = window.innerHeight < this.state.y + height ? (this.state.y - height) : this.state.y;
		const left = window.innerWidth < this.state.x + width ? (this.state.x - width) : this.state.x;
		return {
			overlay: { backgroundColor: 'rgba(255, 255, 255, 0.75)' },
			content: { 
				left: `${left}px`,
				top: `${top}px`, 
				height: `${height}px`,
				width: `${width}px`,
				overflowY: "auto", 
				overflowX: "hidden"
			}
		};
	}

	handleDetailsClick(e) {
		const { clientX, clientY } = e;
		this.setState({isDetailsOpen: true, x: clientX, y: clientY});
		// this.props.getDocumentDetails(this.props, callback);
	}

	render () {
		const { id, timestamp, nome, username } = this.props;
		return (			
			<div className="document-container">
				<div className={`cs-card accesslog-item`} style={{background: "white"}}>	
									
					<div className="accesslog-container">
						<div className="accesslog-row" style={{maxWidth: "40px"}}>
							<div className="accesslog-row-item">
								{id}
							</div>
						</div>
						<div className="accesslog-row">
							<div className="accesslog-row-item">
								{nome}
							</div>
							
						</div>
						<div className="accesslog-row ">
							<div className="accesslog-row-item">
								{moment(timestamp).format("DD/MM/YYYY HH:mm:ss")}
							</div>
							
						</div>
						<div className="accesslog-row">
							<div className="accesslog-row-item">
								{username}
							</div>
						</div>
						{/* <div className="accesslog-row">
							<div className="accesslog-row-item">
								<i 
									className="fa fa-eye pointer hoverable" 
									data-tip="Mais detalhes" 
									onClick={this.handleDetailsClick.bind(this)}
								/>
							</div>
						</div> */}
					</div>
					
					<LightBox						
						isOpen={this.state.isDetailsOpen}						 
						onClose={() => this.setState({isDetailsOpen: false})}
						style={this.getStyle(400, 400)}>
							{/* {this.setFakeJson(this.props)} */}
					</LightBox>
				</div>						
			</div>);
	}
}

AccessItem.propTypes = {
	index: PropTypes.number.isRequired,
	id: PropTypes.number.isRequired,
	timestamp: PropTypes.string.isRequired,
	nome: PropTypes.string.isRequired,
	username: PropTypes.string.isRequired,
	email: PropTypes.string.isRequired
};


// WEBPACK FOOTER //
// ./src/components/ManageUser/AccessItem.js